export function getElementFromSkills(element) {
    if (element.Education.List !== undefined || element.Training.List !== undefined || element.Certification.List !== undefined) {
        if (element.Education.List !== undefined && !Array.isArray(element.Education.List)) {
            element.Education["List"] = [element.Education["List"]]
        }
        if (element.Training.List !== undefined && !Array.isArray(element.Training.List)) {
            element.Training["List"] = [element.Training["List"]]
        }
        if (element.Certification.List !== undefined && !Array.isArray(element.Certification.List)) {
            element.Certification["List"] = [element.Certification["List"]]
        }
        return element
    } else {
        return element
    }
}

export function getLanguageFromFileName(fileName) {
    let splitCharacterIndex = fileName.lastIndexOf("- ")
    return (fileName.substring(splitCharacterIndex + 2, splitCharacterIndex + 4)).toLowerCase()
}
export const handleRequestSort = (event, property,setOrder,setOrderBy,orderBy,order) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
};
export const createSortHandler = (property,setOrder,setOrderBy,orderBy,order) => (event) => {
    handleRequestSort(event, property,setOrder,setOrderBy,orderBy,order);
};
export function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}
export function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

export function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}